export const STORAGE_LANGUAGE_KEY = 'language';
export const STORAGE_AUTH_TOKEN = 'authToken';
export const STORAGE_DISTINCT_ID = 'distinctId';
export const MAX_AGE = 34560000; // 400 days
